/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import Heading from '@atlaskit/heading';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { Box, xcss } from '@atlaskit/primitives';
import { h700 } from '@atlaskit/theme/typography';
var formHeaderContentStyles = xcss({
  minWidth: '100%',
  marginBlockStart: 'space.100'
});
var formHeaderDescriptionStyles = xcss({
  marginBlockStart: 'space.100'
});
var formHeaderTitleStyles = css({
  lineHeight: "var(--ds-font-lineHeight-500, 32px)",
  marginBlockStart: 0,
  marginInlineEnd: "var(--ds-space-400, 32px)",
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
});
var formHeaderWrapperStyles = css({
  fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var lightH700Styles = css(h700({
  theme: {
    mode: 'light'
  }
}));
var FormHeaderContent = function FormHeaderContent(_ref) {
  var children = _ref.children;
  return jsx(Box, {
    xcss: formHeaderContentStyles
  }, children);
};
var FormHeaderDescription = function FormHeaderDescription(_ref2) {
  var children = _ref2.children;
  return jsx(Box, {
    xcss: formHeaderDescriptionStyles
  }, children);
};
var FormHeaderTitle = function FormHeaderTitle(_ref3) {
  var children = _ref3.children;
  return jsx("h2", {
    css: [lightH700Styles, formHeaderTitleStyles]
  }, children);
};
var FormHeaderWrapper = function FormHeaderWrapper(_ref4) {
  var children = _ref4.children;
  return jsx("div", {
    css: formHeaderWrapperStyles
  }, children);
};

/**
 * __Form header__.
 *
 * A form header contains the form component's heading and subheadings. This provides the correct padding
 * and styling for it.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
 */
var FormHeader = function FormHeader(_ref5) {
  var children = _ref5.children,
    description = _ref5.description,
    title = _ref5.title;
  return getBooleanFF('platform.design-system-team.form-header-typography-updates_4f1g6') ? jsx(Box, null, title && jsx(Heading, {
    size: "large"
  }, title), description && jsx(FormHeaderDescription, null, description), children && jsx(FormHeaderContent, null, children)) : jsx(FormHeaderWrapper, null, title && jsx(FormHeaderTitle, null, title), description && jsx(FormHeaderDescription, null, description), children && jsx(FormHeaderContent, null, children));
};
export default FormHeader;
export { FormHeaderContent, FormHeaderDescription, FormHeaderTitle };